import { render, staticRenderFns } from "./SnackBarDraggable.vue?vue&type=template&id=8791fda6&scoped=true"
import script from "./SnackBarDraggable.vue?vue&type=script&lang=js"
export * from "./SnackBarDraggable.vue?vue&type=script&lang=js"
import style0 from "./SnackBarDraggable.vue?vue&type=style&index=0&id=8791fda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8791fda6",
  null
  
)

export default component.exports